import React from "react";
import Video from "../Components/Video";
import Navbar from "../Components/Navbar";
const LandingPage = () => {
  return (
    <div style={{overflowX:'hidden'}}>
      {/* <div>
        <Navbar />
      </div> */}

      <div className="container py-5 my-5" style={{ paddingTop: "8" }}>
        <Video />
        <div style={{ height: "100vh" }}></div>
      </div>
    </div>
  );
};

export default LandingPage;
